import React from 'react';
import Modal from 'react-modal';

Modal.setAppElement('body');

import { Close } from '../../icons';
import {
  StyledCloseButton,
  StyledOverlay,
  StyledPanel,
} from './ModalPanel.styles';
import { IModalPanelProps } from './ModalPanel.types';

const ModalPanel = ({
  ariaLabel = 'Close',
  children,
  open,
  user,
  handleCloseModal,
}: IModalPanelProps): JSX.Element => {
  return (
    <Modal
      bodyOpenClassName="prevent-scroll"
      className=" "
      contentElement={(props, children) => (
        <StyledPanel {...props}>{children}</StyledPanel>
      )}
      isOpen={open}
      onRequestClose={handleCloseModal}
      overlayClassName=" "
      overlayElement={(props, contentElement) => (
        <StyledOverlay {...props} user={user}>
          {contentElement}
        </StyledOverlay>
      )}
      shouldCloseOnOverlayClick={true}
    >
      <StyledCloseButton aria-label={ariaLabel} onClick={handleCloseModal}>
        <Close />
      </StyledCloseButton>
      {children}
    </Modal>
  );
};

export default ModalPanel;
